"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateTurn = void 0;
const getStats_1 = require("../utils/getStats");
const simulate_1 = require("./piece/simulate");
const simulateTurn = (currentTurn, board, pieceRegistry, stores) => {
    const pieces = [];
    board.forEachPiece((id) => {
        const piece = pieceRegistry.getPieceById(id);
        if (piece === null) {
            return;
        }
        pieces.push({ piece, speed: (0, getStats_1.getStats)(piece, stores.creatures).speed });
    });
    pieces.sort((a, b) => b.speed - a.speed);
    for (const entry of pieces) {
        takePieceTurn(currentTurn, board, pieceRegistry, entry.piece.id, stores);
    }
    for (const entry of pieces) {
        const combat = stores.combatStore.getPiece(entry.piece.id);
        if (combat.currentHealth > 0) {
            stores.combatStore.updatePiecePartial(entry.piece.id, {
                battleStats: Object.assign(Object.assign({}, combat.battleStats), { turnsSurvived: combat.battleStats.turnsSurvived + 1 }),
            });
        }
    }
};
exports.simulateTurn = simulateTurn;
const takePieceTurn = (currentTurn, board, pieceRegistry, pieceId, stores) => {
    if (!board.containsPiece(pieceId)) {
        return;
    }
    const piece = pieceRegistry.getPieceById(pieceId);
    if (!piece) {
        return;
    }
    (0, simulate_1.simulatePiece)(currentTurn, board, pieceRegistry, pieceId, stores);
};
